export function changeArrayAtIndex(array, itemIndex, itemChanger) {
    if (itemIndex < 0) {
        throw new Error('Array item not found');
    }
    return [
        ...array.slice(0, itemIndex),
        itemChanger(array[itemIndex]),
        ...array.slice(itemIndex + 1),
    ];
}

export function changeArray(array, itemIndexFinder, itemChanger) {
    const itemIndex = array.findIndex(itemIndexFinder);
    if (itemIndex < 0) {
        throw new Error('Array item not found');
        // return array;
    }
    return changeArrayAtIndex(array, itemIndex, itemChanger);
}

export function toggleArrayItem(array, item, itemIdentifier = (it) => it) {
    const itemIndex = array.findIndex(
        (it) => itemIdentifier(it) === itemIdentifier(item)
    );
    if (itemIndex < 0) {
        return [...array, item];
    }
    return [...array.slice(0, itemIndex), ...array.slice(itemIndex + 1)];
}

export function changeMatrix(matrix, row, col, itemChanger) {
    return changeArrayAtIndex(matrix, row, (rowArray) =>
        changeArrayAtIndex(rowArray, col, itemChanger)
    );
}
